export default __webpack_public_path__ + "static/media/spinner-boost-red.b27fbc22.gif";